<template>
    <div id="mask" v-show="show">
        <div id="box" class="window-scale">
            <div ref="viewer" id="viewer" class="window-scale" :style="{ transform: `scale(${zoon_scale})` }">
                <div ref="img-box" id="img-box">
                    <img crossorigin="Anonymous"
                        :src="`${currentExamPath}/${currentExamIndex + (isShowAnswer ? 'a' : 'q')}.png`"
                        id="question-img">
                </div>
                <canvas id="exam-canvas" :width="1920" :height="1080"
                    style="position: relative; left: 0px; top: 0px; background-color:rgba(255, 255, 255, 0.00);"></canvas>
            </div>
            <div id="toolbar">
                <div :class="[TOOLS.SELECTION.TOOL, { selected: store.nowTool == TOOLS.SELECTION.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.SELECTION.TOOL] }]"
                    @click="triggerTool(TOOLS.SELECTION.TOOL)"></div>
                <div :class="[TOOLS.PEN.TOOL, { selected: store.nowTool == TOOLS.PEN.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.PEN.TOOL] }]"
                    @click="triggerTool(TOOLS.PEN.TOOL)"></div>
                <div :class="[TOOLS.HIGHLIGHTER.TOOL, { selected: store.nowTool == TOOLS.HIGHLIGHTER.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.HIGHLIGHTER.TOOL] }]"
                    @click="triggerTool(TOOLS.HIGHLIGHTER.TOOL)"></div>
                <div :class="[TOOLS.ERASER.TOOL, { selected: store.nowTool == TOOLS.ERASER.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.ERASER.TOOL] }]"
                    @click="triggerTool(TOOLS.ERASER.TOOL)"></div>
                <div :class="[TOOLS.CLEAR.TOOL, { selected: store.nowTool == TOOLS.CLEAR.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.CLEAR.TOOL] }]"
                    @click="triggerTool(TOOLS.CLEAR.TOOL)"></div>
                <div :class="[TOOLS.ZOOM_OUT.TOOL, { selected: store.nowTool == TOOLS.ZOOM_OUT.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.ZOOM_OUT.TOOL] }]"
                    @click="triggerTool(TOOLS.ZOOM_OUT.TOOL)"></div>
                <div :class="[TOOLS.ZOOM_IN.TOOL, { selected: store.nowTool == TOOLS.ZOOM_IN.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.ZOOM_IN.TOOL] }]"
                    @click="triggerTool(TOOLS.ZOOM_IN.TOOL)"></div>
                <div :class="[TOOLS.ZOOM_NORMAL.TOOL, { selected: store.nowTool == TOOLS.ZOOM_NORMAL.TOOL }, hoverCorner, { off: store.toggleTool[TOOLS.ZOOM_NORMAL.TOOL] }]"
                    @click="triggerTool(TOOLS.ZOOM_NORMAL.TOOL)"></div>
            </div>
            <img src="../../assets/common/close.png" id="left-exit-btn" @click="close()" />
            <img src="../../assets/common/close.png" id="right-exit-btn" @click="close()" />
            <div id="show-answer" @click="toggleAns()"> 解答 </div>

            <PaintBoard ref="paintBoard" />
            <ConfirmDialog ref="confirmDialog" />
        </div>
    </div>
</template>

<script>
import PainterProxy from '@/js/painter/proxy';
import { TOOLS } from '@/js/toolbar/tools';
import { store } from '@/store';
import DEFINE from '@/js/painter/define';
import PaintBoard from '../UI/PaintBoard.vue';
import ConfirmDialog from '../dialogs/ConfirmDialog.vue';
import { ALIVE_TYPE } from '../../js/toolbar/tools';
import EventBus from '@/js/event_bus';

export default {
    name: "LessonExamViewer",
    components: {
        PaintBoard,
        ConfirmDialog
    },
    data: function () {
        return {
            store,
            TOOLS,
            show: false,
            currentExamPath: '',
            currentExamIndex: 0,
            isShowAnswer: false,
            zoon_scale: 0.8,
            isPointerDown: false,
            beginPosition: { x: 0, y: 0 },
            pointerPosition: { x: 0, y: 0 }
        }
    },
    methods: {
        close() {
            PainterProxy.getInstance().removeCurrentPainter();
            this.show = false;
        },
        showExam(path, index) {
            const proxy = PainterProxy.getInstance();

            proxy.setCurrentPainter("exam-canvas");
            proxy.clearAll(false);

            this.currentExamPath = path;
            this.currentExamIndex = index;
            this.isShowAnswer = false;

            this.$refs.viewer.style.left = `0px`;
            this.$refs.viewer.style.top = `0px`;
            this.$refs.paintBoard.show = false;

            this.triggerTool(TOOLS.SELECTION.TOOL);

            this.show = true;
        },
        toggleAns() {
            this.isShowAnswer = !this.isShowAnswer;
        },
        triggerTool(tool) {
            if (store.toolMap.get(tool)) {
                switch (store.toolMap.get(tool).KEEP_ALIVE) {
                    case ALIVE_TYPE.KEEP:
                        this.triggerToolFunction(tool);
                        store.nowTool = tool;
                        store.setPreviousTool(tool);
                        break;
                    case ALIVE_TYPE.ONCE:
                        EventBus.getInstance().emit(TOOLS.SELECTION.TOOL);
                        this.triggerToolFunction(tool);
                        store.nowTool = tool;
                        break;
                    case ALIVE_TYPE.NONE:
                        this.triggerToolFunction(tool);
                        store.nowTool = store.prevTool;
                        break;
                }
            } else {
                this.triggerToolFunction(tool);
                store.nowTool = store.prevTool;
            }


            if (tool == TOOLS.TOOL_BOX.TOOL) {
                return;
            }

            if (tool == TOOLS.GO_PAGE.TOOL) {
                return;
            }

            if (tool == TOOLS.WHITE_BOARD.TOOL) {
                store.setWhiteboardDisabledTools();
            }
        },
        triggerToolFunction(tool) {
            const proxy = PainterProxy.getInstance();

            switch (tool) {
                case TOOLS.ERASER.TOOL:
                    proxy.setOperate(DEFINE.OPERATE.ERASER);
                    proxy.changeTool(DEFINE.TOOLS.ERASER);
                    break;
                case TOOLS.PEN.TOOL:
                    proxy.setOperate(DEFINE.OPERATE.PEN);
                    proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.PEN));

                    if (store.nowTool == TOOLS.PEN.TOOL) {
                        this.$refs.paintBoard.operate = DEFINE.OPERATE.PEN;
                        this.$refs.paintBoard.updateBoard();
                        this.$refs.paintBoard.show = true;
                    }
                    break;
                case TOOLS.HIGHLIGHTER.TOOL:
                    proxy.setOperate(DEFINE.OPERATE.HIGHLIGHTER);
                    proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.HIGHLIGHTER));

                    if (store.nowTool == TOOLS.HIGHLIGHTER.TOOL) {
                        this.$refs.paintBoard.operate = DEFINE.OPERATE.HIGHLIGHTER;
                        this.$refs.paintBoard.updateBoard();
                        this.$refs.paintBoard.show = true;
                    }
                    break;
                case TOOLS.CLEAR.TOOL:
                    this.$refs.confirmDialog.showDialog(
                        "提示！",
                        "確定刪除當前繪圖物件？",
                        () => {
                            proxy.clearAll();
                        },
                        null
                    );
                    break;
                case TOOLS.SELECTION.TOOL:
                    PainterProxy.getInstance().setOperate(DEFINE.OPERATE.SELECTION);
                    PainterProxy.getInstance().changeTool(null);
                    break;
                case TOOLS.ZOOM_NORMAL.TOOL:
                    this.zoon_scale = 0.8;
                    this.$refs.viewer.style.left = `${0}px`;
                    this.$refs.viewer.style.top = `${0}px`;
                    break;
                case TOOLS.ZOOM_IN.TOOL:
                    this.zoon_scale += 0.05;
                    break;
                case TOOLS.ZOOM_OUT.TOOL:
                    this.zoon_scale -= 0.05;

                    if (this.zoon_scale < 0.1) this.zoon_scale = 0.1;
                    break;
            }
        }
    },
    mounted: function () {
        PainterProxy.getInstance().setPainter("exam-canvas", false, false);

        this.$el.getElementsByClassName("canvas-container")[0].style.left = "50%";
        this.$el.getElementsByClassName("canvas-container")[0].style.transform = "translateX(-50%)";

        this.$el.addEventListener("pointerdown", (e) => {
            if (store.nowTool != TOOLS.SELECTION.TOOL) return;

            const target = this.$refs["img-box"];
            const minX = this.$refs.viewer.offsetLeft + target.offsetLeft - target.clientWidth / 2;
            const maxX = this.$refs.viewer.offsetLeft + target.offsetLeft + target.clientWidth / 2;
            const minY = this.$refs.viewer.offsetTop + target.offsetTop;
            const maxY = this.$refs.viewer.offsetTop + target.offsetTop + target.clientHeight;

            if (minX < e.clientX && e.clientX < maxX && minY < e.clientY && e.clientY < maxY) {
                this.isPointerDown = true;
                this.pointerPosition = { x: e.clientX, y: e.clientY }
                this.beginPosition = { x: this.$refs.viewer.offsetLeft, y: this.$refs.viewer.offsetTop }
            }
        })

        this.$el.addEventListener("pointermove", (e) => {
            if (this.isPointerDown) {
                // 因為img-box的translateX為-50%，故計算X軸時須以物件中心為0，左右延伸。
                const target = this.$refs["img-box"];
                const minX = this.$refs.viewer.offsetLeft + target.offsetLeft - target.clientWidth / 2;
                const maxX = this.$refs.viewer.offsetLeft + target.offsetLeft + target.clientWidth / 2;
                const minY = this.$refs.viewer.offsetTop + target.offsetTop;
                const maxY = this.$refs.viewer.offsetTop + target.offsetTop + target.clientHeight;

                if (minX < e.clientX && e.clientX < maxX && minY < e.clientY && e.clientY < maxY) {
                    const offsetX = e.clientX - this.pointerPosition.x;
                    const offsetY = e.clientY - this.pointerPosition.y;

                    this.$refs.viewer.style.left = `${this.beginPosition.x + offsetX}px`;
                    this.$refs.viewer.style.top = `${this.beginPosition.y + offsetY}px`;
                }
            }
        })

        this.$el.addEventListener("pointerup", (e) => {
            this.isPointerDown = false;
        })

        this.$el.addEventListener("pointerout", (e) => {
            this.isPointerDown = false;
        })

        this.$el.addEventListener("wheel", (e) => {
            this.zoon_scale -= e.deltaY / 1000;

            if (this.zoon_scale < 0.1) this.zoon_scale = 0.1;
        })
    }
}
</script>

<style scoped>
#mask {
    z-index: var(--z-index-lesson-exam);
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.5);
}

#box {
    position: absolute;
    width: calc(100% / var(--window-scale));
    height: calc(100% / var(--window-scale));
    left: 0%;
    top: 0%;
    transform-origin: left top;
}

#viewer {
    position: absolute;
    width: 100%;
}

#img-box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    transform-origin: left top;
    height: 900px;
    width: 1600px;
    background-color: white;
}

#question-img {
    position: absolute;
    max-height: -webkit-fill-available;
    /* height: 900px; */
    /* width: inherit; */
    left: 0;
}

#toolbar {
    background-color: white;
    position: absolute;
    display: flex;
    width: 600px;
    height: 80px;
    transform: translate(-50%, 0%);
    bottom: 30px;
    left: 50%;
}

#toolbar div {
    width: 100%;
    background-size: cover;
}

#show-answer {
    position: absolute;
    width: 120px;
    height: 40px;
    font-size: 30px;
    text-align: center;
    line-height: 40px;
    right: 10%;
    bottom: 6%;
    color: white;
    background-color: #1b6abb;
    border-radius: 5px;
    cursor: pointer;
}

#left-exit-btn {
    position: absolute;
    bottom: 5%;
    left: 5%;
}

#right-exit-btn {
    position: absolute;
    bottom: 5%;
    right: 5%;
}
</style>